import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import api from "@/services/api";
import store from './store'
import { format, parseISO, parse } from "date-fns";
import VueGtag from "vue-gtag";
import "./scss/main.scss";
import 'bootstrap';

api.interceptors.response.use(
    response => {
        return Promise.resolve(response);
    },
    error => {
        if (error.response.status)
        {
            switch (error.response.status)
            {
                case 401:
                {
                    if (!store.state.isSignedIn) { // the user might be on a page that doesn't require a sign in
                        break;
                    }
                    console.log('401 error - Session expired');
                    store.dispatch('signOut')
                    .then(() => {
                        router.replace('/login');
                    });
                    
                    break;
                }
            }

            return Promise.reject(error);
        }
    }
);

const app = createApp(App);

app.config.globalProperties.$accessLevel = {
    basic: 1,
    sensitive: 2,
    full: 3,
}

app.config.globalProperties.$filters = {
    formatDate(value) {
        var dateValue = parseISO(String(value));
        return format(dateValue, 'dd/MM/yyyy');
    },
    formatDateVerbose(value) {
        var dateValue = parseISO(String(value));
        return format(dateValue, 'Mo MMMM yyyy');
    },
    formatDateMonthYear(value) {
        var dateValue = parseISO(String(value));
        return format(dateValue, 'MMMM yyyy');
    },
    formatDateTime(value) {
        var dateValue = parseISO(String(value));
        return format(dateValue, 'dd/MM/yyyy HH:mm');
    },
    formatTime(value) {
        var dateValue = parse(String(value), "HH:mm:ss", new Date());
        return format(dateValue, 'HH:mm');
    },
    formatMoney(value) {
        if(value === null)
        {
            return '';
        }
        
        return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP' }).format(value);
    },
    canAccess(value) {
        return store.state.currentAccessLevel >= value;
    },
}


app
.use(store)
.use(router)
.use(VueGtag, {
    config: { 
        id: process.env.VUE_APP_GOOGLE_ANALYTICS_TAG,
        params: {
            cookie_flags: process.env.VUE_APP_GOOGLE_ANALYTICS_COOKIE_FLAGS,
            cookie_domain: process.env.VUE_APP_GOOGLE_ANALYTICS_COOKIE_DOMAIN,
        },
    }
}, router)
.mount('#app');